import {
    getProfile as rpcGetProfile,
    updateProfile as rpcUpdateProfile,
} from "./postgre/userApi";

export const getProfile = async () => rpcGetProfile();

export const updateProfile = async (payload) => rpcUpdateProfile(payload);
